var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"max-width":"300","top":"","nudge-top":"-10","disabled":!_vm.truncated,"open-delay":"600"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('p',_vm._g(_vm._b({ref:"text",staticClass:"truncated-text"},'p',attrs,false),on),[_c('span',[_vm._v(_vm._s(_vm.text))])])]}}])},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }